import { render, staticRenderFns } from "./set_bill_of_materials.vue?vue&type=template&id=f4c83052&"
import script from "./set_bill_of_materials.vue?vue&type=script&lang=js&"
export * from "./set_bill_of_materials.vue?vue&type=script&lang=js&"
import style0 from "./set_bill_of_materials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports